import { serializable, alias, object, list, primitive } from 'serializr';

export class BestFitRegion {
  @serializable(alias('id', primitive()))
  id?: number;

  @serializable(alias('user_location_label', primitive()))
  label?: string;

  @serializable(alias('id', primitive()))
  value?: string;
}
